/* @flow */
import assetRoutes from './asset';
import companyRoutes from './company';
import contractRoutes from './contract';
import costCentreRoutes from './costCentre';
import projectRoutes from './project';
import accountRoutes from './account';
import locationRoutes from './location';
import manufacturerRoutes from './manufacturer';
import productRoutes from './product';
import userRoutes from './user';

import * as _RouterGenerator from './RouteGenerator';

export const asset: Object = assetRoutes;
export const company: Object = companyRoutes;
export const contract: Object = contractRoutes;
export const costCentre: Object = costCentreRoutes;
export const project: Object = projectRoutes;
export const account: Object = accountRoutes;
export const location: Object = locationRoutes;
export const manufacturer: Object = manufacturerRoutes;
export const product: Object = productRoutes;
export const user: Object = userRoutes;

export const RouterGenerator: Object = _RouterGenerator;
export const router: Object = _RouterGenerator.router;
export const generateUrl: Function = _RouterGenerator.generateRoute;
